import { Button } from "@heroui/react";
import React, { memo, useCallback } from "react";
import { FormattedMessage } from "react-intl";

export type Run = (action: () => Promise<boolean>) => void;

export const ANSWER_CLASS = "w-full justify-start";
export const QUESTION_CLASS = "text-lg font-semibold";

type AnswerButtonProps<T> = {
    value: T;
    labelId: string;
    isPending: boolean;
    onSelect: (value: T) => void;
};

const AnswerButtonImpl = <T,>({ value, labelId, isPending, onSelect }: AnswerButtonProps<T>) => {
    const handlePress = useCallback(() => onSelect(value), [onSelect, value]);
    return (
        <Button className={ANSWER_CLASS} variant="outline" isDisabled={isPending} onPress={handlePress}>
            <FormattedMessage id={labelId} />
        </Button>
    );
};

export const AnswerButton = memo(AnswerButtonImpl) as typeof AnswerButtonImpl;

type LaterButtonProps = { isPending: boolean; onLater?: () => void };

const LaterButtonImpl = ({ isPending, onLater }: LaterButtonProps) =>
    onLater ? (
        <Button className={ANSWER_CLASS} variant="tertiary" isDisabled={isPending} onPress={onLater}>
            <FormattedMessage id="app.agent.sortQuestions.later" />
        </Button>
    ) : null;

/** Only the agent chat passes `onLater`; the modal has its own skip button. */
export const LaterButton = memo(LaterButtonImpl);
